import React from 'react';
import { ITableColumns, ITableDataSource } from 'models/table';
import Button from 'components/atoms/Button';
import { IAmmunitionAttachments, IAmmunitionTransactions } from 'models/ancillaries';
import { EIconTypes } from 'constants/Icons';
import { EButtonVariants } from 'constants/Buttons';
import { downloadAncillaryAttachment } from 'requests/attachment';
import { Link } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { parseDictionary } from 'helpers/dictionary';
import { formatDate } from 'utils/date';
import { IDictionary } from 'models/dictionary';

interface IAncillariesTranslationsTableColumns {
  handleDelete: ((arg: string) => void) | null;
  discardableTransactionId: string | null;
  dateFormat: string;
}

export const AmmunitionTranslationsTableColumns = ({
  handleDelete,
  discardableTransactionId,
  dateFormat,
}: IAncillariesTranslationsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
    key: 'transactionType',
    title: 'ammunitionDetails.transactions.transactionType.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f510',
    key: 'date',
    title: 'ammunitionDetails.transactions.DateAndTime.column',
    dateFormat,
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f511',
    key: 'createdDate',
    title: 'ammunitionDetails.transactions.createDate.column',
    dateFormat,
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f513',
    key: 'owner',
    title: 'ammunitionDetails.transactions.owner.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f514',
    key: 'keeper',
    title: 'ammunitionDetails.transactions.keeper.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f517',
    key: '',
    title: 'ammunitionTable.accordion.action.column',
    isSortable: false,
    width: '80px',
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) => (
      <div>
        {props.detailsVisible && (
          <Link to={ERouteLinks.ViewTransaction.replace(':id', props.id)}>
            <Button
              variant={EButtonVariants.outlined}
              tableButton={true}
              icon={EIconTypes.view}
            />
          </Link>
        )}
        {props.id === discardableTransactionId && handleDelete && (
          <Button
            variant={EButtonVariants.outlined}
            icon={EIconTypes.delete}
            onClick={() => handleDelete(props.id)}
          />
        )}
      </div>
    ),
  },
];

export const mapAmmunitionTranslationsToDataSource = (
  transactions: IAmmunitionTransactions[],
): ITableDataSource[] =>
  transactions.map((transaction) => ({
    id: transaction.uniqueId,
    date: transaction.date,
    createdDate: transaction.createdDate,
    transactionType: transaction.transactionType,
    owner: transaction.owner,
    keeper: transaction.keeper,
    detailsVisible: transaction.detailsVisible,
  }));

interface IAncillariesAttachmentsTableColumns {
  ancillaryId: string;
  handleView: (arg: string) => void;
  handleDelete: (arg: string) => void;
  dateFormat: string;
}

export const AmmunitionAttachmentsTableColumns = ({
  ancillaryId,
  handleView,
  handleDelete,
  dateFormat,
}: IAncillariesAttachmentsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f510',
    key: 'createdDate',
    title: 'ammunitionDetails.attachments.dateAndTime.column',
    dateFormat,
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
    key: 'name',
    title: 'ammunitionDetails.attachments.attachmentName.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
    key: 'size',
    title: 'ammunitionDetails.attachments.attachmentSize.column',
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
    key: 'transactionType',
    title: 'ammunitionDetails.attachments.transactionType.column',
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-b369-304a6f32f517',
    key: '',
    title: 'ammunitionTable.accordion.action.column',
    isSortable: false,
    width: '80px',
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) => (
      <div>
        <Button
          variant={EButtonVariants.outlined}
          tableButton={true}
          icon={EIconTypes.download}
          onClick={() =>
            downloadAncillaryAttachment(ancillaryId, props.id, props.name, props.type)
          }
        />
        {props.isReport ? (
          <Button
            variant={EButtonVariants.outlined}
            tableButton={true}
            icon={EIconTypes.view}
            onClick={() => handleView && handleView(props.id)}
          />
        ) : (
          <Button
            variant={EButtonVariants.outlined}
            tableButton={true}
            icon={EIconTypes.delete}
            onClick={() => handleDelete && handleDelete(props.id)}
          />
        )}
      </div>
    ),
  },
];

export const mapAmmunitionAttachmentsToDataSource = (
  attachments: IAmmunitionAttachments[],
  transactionType: IDictionary[] | null,
  dateFormat: string,
): ITableDataSource[] =>
  attachments.map((attachment) => ({
    id: attachment.uniqueId,
    createdDate: attachment.createdDate,
    name: attachment.name,
    type: attachment.type,
    size: Math.trunc(Number(attachment.size) / 1024),
    transactionType: `${
      attachment.transactionTypeUniqueId
        ? parseDictionary(transactionType, 'name')[attachment.transactionTypeUniqueId]
        : ''
    } ${formatDate(attachment.transactionTime, dateFormat)}`,
  }));
